// import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import i18next from 'i18next';
import { Maybe } from 'models/types';
import { ReactNode, useEffect, useState } from 'react';
import TextField from '../TextField';
import { AutoCompleteOption } from './autoComponetSelect.interface';

interface AutoCompleteSelectPropsInterface {
  label?: string;
  defaultValue?: string;
  placeholder?: string;
  noOptionsText?: string;
  getOptions?: (input: string) => void;
  mustSetDefaultValue?: boolean;
  options: AutoCompleteOption[];
  renderedOption?: (props: React.HTMLAttributes<HTMLLIElement>, option: any) => ReactNode;
  onChange?: (value: Maybe<any>) => void;
}

export default function AutoCompleteSelect({
  label,
  defaultValue,
  placeholder = '',
  noOptionsText = i18next.t('defaults.fields.noOptionText'),
  options = [],
  mustSetDefaultValue = false,
  getOptions,
  renderedOption,
  onChange,
}: AutoCompleteSelectPropsInterface) {
  const getDefaultValue = () => {
    const founded = options.find((e) => e.id === defaultValue);
    return founded || null;
  };

  const [value, setValue] = useState<Maybe<AutoCompleteOption>>();
  // const [defaultSelectedValue] = useState<Maybe<AutoCompleteOption>>(defaultValue ? getDefaultValue() : null);
  const [inputValue, setInputValue] = useState(defaultValue || '');
  const [defaultSelectedValue, setDefaultSelectedValue] = useState<Maybe<AutoCompleteOption>>(
    defaultValue ? getDefaultValue() : null
  );
  const [renderField, setRenderField] = useState<boolean>(!mustSetDefaultValue);
  useEffect(() => {
    getOptions && getOptions(inputValue);
  }, [inputValue]);

  useEffect(() => {
    if (defaultValue && options.length) {
      const data = getDefaultValue();
      if (data) {
        setDefaultSelectedValue(data);
        onChange && onChange(data);
        setRenderField(true);
      }
    }
  }, [defaultValue]);
  return renderField ? (
    <Autocomplete
      filterOptions={(x) => x}
      options={options}
      getOptionLabel={(option) => option.name || option.id}
      autoComplete
      includeInputInList
      value={value}
      defaultChecked
      noOptionsText={noOptionsText}
      defaultValue={defaultSelectedValue}
      onChange={(event: any, newValue) => {
        // setOptions(newValue ? [newValue, ...options] : options);
        setValue(newValue);
        onChange && onChange(newValue);
      }}
      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue);
      }}
      fullWidth
      renderInput={(params) => {
        return (
          <div ref={params.InputProps.ref}>
            <TextField type="text" label={label} placeholder={placeholder} inputProps={params.inputProps} />
          </div>
        );
      }}
      renderOption={(props, option) => {
        return (
          (renderedOption && renderedOption(props, option)) || (
            <li {...props}>
              <span>{option.name}</span>
            </li>
          )
        );
      }}
    />
  ) : (
    <div></div>
  );
}
